import { render } from "./SigningApp.vue?vue&type=template&id=4fe46526"
import script from "./SigningApp.vue?vue&type=script&lang=js"
export * from "./SigningApp.vue?vue&type=script&lang=js"
script.render = render

export default script